module.exports = __webpack_public_path__ + "static/media/ner_mammography.2fe11a27.png";